module.exports = __webpack_public_path__ + "img/add_chart_icon.917e397f.svg";